export default [
    {
        path: '/procurement/procurement-payment',
        name: 'procurement-payment',
        props: true,
        component: () => import('@/views/procurement/payment/index.vue'),
        meta: {
            pageTitle: 'Payment',
            breadcrumb: [
                {
                text: 'Payment',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/procurement-payment/add',
        name: 'create-procurement-payment',
        component: () => import('@/views/procurement/payment/create.vue'),
        meta: {
            pageTitle: 'Create Payment',
            breadcrumb: [
                {
                text: 'Payment',
                to: { name: 'procurement-payment' },
                },
                {
                text: 'Create Payment',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/procurement-payment/:id',
        name: 'detail-procurement-payment',
        props: true,
        component: () => import('@/views/procurement/payment/detail.vue'),
        meta: {
            pageTitle: 'Detail Payment',
            breadcrumb: [
                {
                text: 'Payment',
                to: { name: 'procurement-payment' },
                },
                {
                text: 'Detail Payment',
                active: true,
                },
            ],
        },
    },
]